module.exports = __webpack_public_path__ + "b9722090d23eda9bc904f2d7ed91204b.svg";